/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import {
  VideoContainer,
  VideoContent,
  VideoContentText,
  VideoProgressIndicator,
  VideoProgressIndicatorIn,
} from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { Load } from '../../ui/styled';

export default withFocusable({})(function VideoButton({
  item,
  spaced,
  focused,
  onPress,
  loading,
}: {
  item?: { cover?: unknown; title?: string };
  spaced?: boolean;
  focused?: boolean;
  onPress?: () => void;
  loading?: boolean;
}) {
  return (
    <>
      <VideoContainer onPress={onPress} spaced={spaced}>
        <VideoContent source={item?.cover} focused={focused} loading={loading}>
          {loading ? <Load flat /> : null}
          {/* {
                        focused ? 
                            <VideoProgressIndicator>
                                <VideoProgressIndicatorIn />
                            </VideoProgressIndicator>
                        : null
                    } */}
        </VideoContent>
        <VideoContentText>{item?.title}</VideoContentText>
      </VideoContainer>
    </>
  );
});
